<template>
  <NLink
    to="/components/button"
    label="Disabled Link"
    disabled
  />
</template>
